import { render, staticRenderFns } from "./Buchungskonto.vue?vue&type=template&id=5ad50edd&"
import script from "./Buchungskonto.vue?vue&type=script&lang=js&"
export * from "./Buchungskonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports